import {I18n} from '@aws-amplify/core';
import {Cache} from '@aws-amplify/cache';

import {
    Box,
    Center,
    Group,
    Progress,
    Stack,
    Text,
    Title
} from '@mantine/core';
import {
    NextButton,
    PlatformLoader
} from '@pac/platform-ui-components';
import {AiOutlineArrowRight} from 'react-icons/ai';
import {
    useEffect,
    useRef,
    useState
} from 'react';

import {AUTH_TIMEOUT_MS} from '../config';

const PROGRESS_INTERVAL_MS = 100;

const CancelLink = () => (
    <NextButton
        variant={'outline'}
        rightSection={<AiOutlineArrowRight/>}
        onClick={() => {
            Cache.setItem('pac-authorizing', 'no');
            window.location.assign('/accounts');
        }}
    >
        {I18n.get('Start Over')}
    </NextButton>
);

const label = ['Authorizing', 'Please wait']
    .map((item) => I18n.get(item))
    .join('...');

export const AuthorizingIndicator = () => {

    const [showCancelLink, setShowCancelLink] = useState(false)
    const [progress, setProgress] = useState(0)
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

    useEffect(() => {
        const cancelTimer = setTimeout(() => {
            setShowCancelLink(true)
        }, 3000)

        intervalRef.current = setInterval(() => {
            setProgress((prev) => {
                const next = prev + (PROGRESS_INTERVAL_MS / AUTH_TIMEOUT_MS) * 100;
                if (next >= 100) {
                    if (intervalRef.current) clearInterval(intervalRef.current);
                    return 100;
                }
                return next;
            });
        }, PROGRESS_INTERVAL_MS);

        return () => {
            clearTimeout(cancelTimer);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [])

    const secondsRemaining = Math.max(0, Math.ceil((AUTH_TIMEOUT_MS - (progress / 100) * AUTH_TIMEOUT_MS) / 1000));

    return (
        <Stack>
            <Box my={'xl'}>
                <PlatformLoader message={label}/>
            </Box>

            <Box mx={'auto'} style={{width: '100%', maxWidth: 400}}>
                <Progress
                    value={progress}
                    size="sm"
                    color={progress < 70 ? 'blue' : progress < 90 ? 'orange' : 'red'}
                    animated
                />
                <Text size="xs" c="dimmed" ta="center" mt={4}>
                    {secondsRemaining > 0
                        ? `${secondsRemaining}s ${I18n.get('remaining')}`
                        : I18n.get('Redirecting...')}
                </Text>
            </Box>

            {showCancelLink ? <Center>
                <Group>
                    <Title order={5}>Cancelled authentication? </Title>
                    <CancelLink/>
                </Group>
            </Center> : null}
        </Stack>
    );
};
